import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { environment } from 'src/environments/environment';

export const devOnlyGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);
  if (environment.production) {
    return router.createUrlTree(['/attivita']);
  }
  return true;
};
